module.exports = __webpack_public_path__ + "../resources/images/illustration_trash-ad56de8f0870bf0b4ecce327bef31f11.svg";